// useArticlePriceCache.jsx

import { useRef } from "react";

const createDefaultPriceStep = (articleNo) => ({
  articleNo: articleNo,
  description: "",
  amount: 1,
  price: 0,
});

export const useArticlePriceListCache = () => {
  const cache = useRef(new Map());

  const get = (articleNo) => cache.current.get(articleNo);

  const set = (articleNo, priceSteps) => {
    const noPriceListEntry = !priceSteps || priceSteps.length === 0;

    cache.current.set(articleNo, {
      noPriceListEntry,
      priceSteps: noPriceListEntry
        ? [createDefaultPriceStep(articleNo)]
        : priceSteps,
    });
  };

  const clear = () => cache.current.clear();

  return {
    get,
    set,
    clear,
  };
};
